export default {
  // ── NAV ──
  'nav.poti': 'Poti',
  'nav.izhodisca': 'Izhodišča',
  'nav.galerija': 'Galerija',
  'nav.vreme': 'Vreme',
  'nav.o_nas': 'O nas',
  'nav.zacni_pot': 'Začni pot',
  'nav.odpri_meni': 'Odpri meni',
  'nav.zapri_meni': 'Zapri meni',
  'nav.preskoci': 'Preskoči na vsebino',

  // ── HERO ──
  'hero.badge': 'Turistično društvo STEZA — Šmarna gora',
  'hero.title': 'POT NA PESKE',
  'hero.subtitle': 'ŠMARNA GORA',
  'hero.desc': 'Ena najlepših, najbolj razgibanih in najbolj prijaznih poti za obiskovalce vseh generacij.',
  'hero.cta_start': 'Začni pot',
  'hero.cta_explore': 'Razišči poti',
  'hero.cta_activities': 'Aktivnosti',
  'hero.scroll': 'Pomakni se',

  // ── INTRO ──
  'intro.badge': 'Dobrodošli',
  'intro.title': 'Šmarna gora, najbolj priljubljen ljubljanski hrib',
  'intro.desc': 'Šmarna gora, najbolj priljubljen ljubljanski hrib, ponuja številne poti za pohodnike, tekače in ljubitelje narave.',
  'intro.highlight': 'Pot na Peske velja za eno najlepših, najbolj razgibanih in najbolj prijaznih poti za obiskovalce vseh generacij.',
  'intro.pot_label': 'Pot na Peske',
  'intro.route': 'Spodnje Pirniče → Šmarna gora',

  // ── ACTIVITIES ──
  'activities.badge': 'Aktivnosti',
  'activities.title': 'RAZISKOVANJE ŠMARNE GORE',
  'activities.hiking.title': 'Pohodništvo na Šmarno goro',
  'activities.hiking.desc': 'Raziščite različne poti, od lažjih sprehodov do zahtevnejših vzponov.',
  'activities.cycling.title': 'Kolesarjenje okoli Šmarne gore',
  'activities.cycling.desc': 'Odkrijte slikovite kolesarske poti v okolici s čudovitimi razgledi.',
  'activities.running.title': 'Tek na Šmarno goro',
  'activities.running.desc': 'Priljubljena destinacija za trail tekače — razgibane poti z idealnim vzponom.',
  'activities.running_around.title': 'Tek okoli Šmarne gore',
  'activities.running_around.desc': 'Ravninski in položni tekaški krogi ob vznožju za rekreativni trening.',
  'activities.walks.title': 'Sprehodi pod Šmarno goro',
  'activities.walks.desc': 'Umirjeni sprehodi po travnikih in gozdnih poteh, idealni za družine.',

  // ── ACCESS ──
  'access.badge': 'Izhodišče',
  'access.title': 'IZHODIŠČE IN DOSTOP',
  'access.desc': 'Pot se začne pri parkirišču LIPA v Spodnjih Pirničah. Dostop je preprost — z avtom ali avtobusom.',
  'access.start_label': 'Izhodišče poti',
  'access.address': 'Spodnje Pirniče 56',
  'access.parking_name': 'Parkirišče LIPA',
  'access.parking': 'Parkirišče',
  'access.free': 'Brezplačno',
  'access.bus': 'Avtobus',
  'access.bus_line': 'Linija 25',
  'access.info1': 'Parkirate vozilo na parkirišču LIPA ali prispete z avtobusom številka 25 neposredno na izhodišče pred gostinski lokal s prelepo teraso, kjer si lahko privoščite osvežilno pijačo ali prigrizek pred začetkom poti.',
  'access.info2': 'Na začetku ob travniku vas ozka pot, posuta s sekanci, vodi proti gozdu, kjer se začne vzpon.',

  // ── PARKING ──
  'parking.hero_title': 'Parkirišče LIPA — Uradno izhodišče',
  'parking.hero_subtitle': 'Spodnje Pirniče 56, 1211 Ljubljana-Šmartno. Brezplačno parkirišče neposredno ob začetku Poti na Peske.',
  'parking.highlight_badge': '⭐ Uradno izhodišče',
  'parking.section_title': 'PARKIRANJE & DOSTOP',
  'parking.intro': 'Parkirišče LIPA je uradno, brezplačno in najbolj priročno izhodišče za Pot na Peske — našo najlepšo pot na Šmarno goro.',
  'parking.address_label': 'Naslov',
  'parking.address_value': 'Spodnje Pirniče 56, 1211 Ljubljana-Šmartno',
  'parking.gps_label': 'GPS Koordinate',
  'parking.gps_value': '46.1176° N, 14.4544° E',
  'parking.what3words': 'what3words',
  'parking.what3words_value': '///vzpon.pesek.lipa',
  'parking.capacity_label': 'Kapaciteta',
  'parking.capacity_value': 'Brezplačno, prostor za 20+ vozil',
  'parking.type_label': 'Tip parkirišča',
  'parking.type_value': 'Odprto makadamsko parkirišče',
  'parking.hours_label': 'Odprto',
  'parking.hours_value': '24/7 — vse dni v letu',
  'parking.bus_info_title': 'Javni prevoz',
  'parking.bus_info': 'Avtobus LPP linija 25 vozi neposredno do postajališča pred parkiriščem. Vožnja iz centra Ljubljane traja približno 30 minut.',
  'parking.facilities_title': 'Infrastruktura',
  'parking.facility_gostilna': 'Gostinski lokal s prelepo teraso tik ob parkirišču',
  'parking.facility_wc': 'WC na voljo pri gostinskem lokalu',
  'parking.facility_info': 'Informativna tabla Pot na Peske na začetku poti',
  'parking.facility_sign': 'Smerokaz STEZA / Pot na Peske',
  'parking.tips_title': 'Koristni nasveti za parkiranje',
  'parking.tip1': 'Med vikendi in prazniki je parkirišče hitro zasedeno — pridite zgodaj (pred 8. uro) za zagotovljeno mesto.',
  'parking.tip2': 'Parkirišče je makadamsko — pozimi bodite pozorni na morebitno poledico na parkirni površini.',
  'parking.tip3': 'Ne puščajte vrednih predmetov v avtomobilu. Parkirate na lastno odgovornost.',
  'parking.tip4': 'Dodatno parkirišče je na voljo pri Gostilni Ledinek v Tacnu (5 min vožnje), če je LIPA polno.',
  'parking.map_title': 'Lokacija na zemljevidu',
  'parking.cta_title': 'Ste pripravljeni na Pot na Peske?',
  'parking.cta_subtitle': 'Parkirajte na LIPA in se podajte na najlepšo pot na Šmarno goro.',
  'parking.cta_btn': 'Začni pot',
  'parking.cta_routes': 'Vse poti',

  // ── HIKING STORY ──
  'story.badge': 'Pot na Peske',
  'story.title': 'OD IZHODIŠČA DO VRHA',
  'story.subtitle': 'Kinematografsko popotovanje skozi vsako etapo poti',
  'story.etapa': 'Etapa',
  'story.blocks.0.title': 'Blag začetek',
  'story.blocks.0.text': 'Sprva se blago vzpnemo po udobni, široki poti, deloma prekriti s skalami in koreninami, kmalu pa zavijemo na čedalje ožjo stezo, ki se nekoliko strmeje vzpne.',
  'story.blocks.0.terrain': 'Široka pot, skale, korenine',
  'story.blocks.1.title': 'Najbolj razgiban del',
  'story.blocks.1.text': 'Hodimo po čedalje bolj peščenih tleh, po skalah in koreninah, deloma tudi po razmeroma globokem žlebu. To je najbolj strm, a tudi najbolj razčlenjen del poti.',
  'story.blocks.1.terrain': 'Peščena tla, skale, žleb',
  'story.blocks.2.title': 'Makadamska cesta',
  'story.blocks.2.text': 'Ko se steza razširi in zravna, smo kmalu na široki makadamski cesti, vozni poti na Šmarno goro, ki pripelje iz Zavrha.',
  'story.blocks.2.terrain': 'Makadam, široka pot',
  'story.blocks.3.title': 'Turško znamenje',
  'story.blocks.3.text': 'Tukaj nas planinska tabla usmeri desno, mimo kužnega oziroma Turškega znamenja, ki spominja na čase turških vpadov.',
  'story.blocks.3.terrain': 'Planinska tabla, zgodovinska točka',
  'story.blocks.4.title': 'Gorjančeva kapelica',
  'story.blocks.4.text': 'Cesta se zmerno vzpenja po gozdu, ki se čez čas razpre. Na levi je Gorjančeva kapelica, kjer je ohranjena navada odlaganja majhnih križev.',
  'story.blocks.4.terrain': 'Gozdna cesta, kapelica',
  'story.blocks.5.title': 'Spodnji Gorjanc — stičišče',
  'story.blocks.5.text': 'Pridemo do Spodnjega Gorjanca, pomembnega stičišča več poti. Tu se križajo smeri proti Grmadi, Pot na korenine (proti Tacnu) in nadaljevanje proti Šmarni gori.',
  'story.blocks.5.terrain': 'Stičišče poti, Grmada, Pot na korenine',
  'story.blocks.6.title': 'Razgledi na Alpe',
  'story.blocks.6.text': 'Pot nadaljujemo med pašnimi travniki, kjer se odprejo razgledi na Kamniško-Savinjske Alpe ter Julijce s Triglavom.',
  'story.blocks.6.terrain': 'Pašni travniki, panoramski razgledi',
  'story.blocks.7.title': 'Sedlo — križišče z Grmado',
  'story.blocks.7.text': 'Na Sedlu se pot križa s smerjo proti Grmadi in združi s potmi iz Tacna, Šmartnega in Vikrč. Od tu naprej lahko izberemo lažjo makadamsko pot ali ožjo, bolj skalnato stezo mimo kapelice sv. Sobote.',
  'story.blocks.7.terrain': 'Sedlo, stičišče Grmada–Šmarna gora, dve možnosti',
  'story.blocks.8.title': 'Vrh — izbira poti',
  'story.blocks.8.text': 'Predlagan je vzpon po zahtevnejši poti in spust po položnejši. Tako izkusite obe plati Šmarne gore in užijete celotno izkušnjo.',
  'story.blocks.8.terrain': 'Dve poti, vzpon in spust',

  // ── HIGHLIGHT ──
  'highlight.title': 'Ena najbolj prijaznih poti na Šmarno goro',
  'highlight.text1': 'To je tudi ena najbolj prijaznih poti na Šmarno goro — nikoli izpostavljena, brez večjih strmin in prijetna za hojo tudi po dežju, ko so številne druge poti blatne.',
  'highlight.text2': 'V prvem delu je zelo razgibana in zato izredno priljubljena med pohodniki, tekači in družinami.',

  // ── VIEWPOINT ──
  'viewpoint.badge': 'Panorama',
  'viewpoint.title': 'RAZGLEDI Z VRHA',
  'viewpoint.desc': 'Na vrhu Šmarne gore si v jasnem vremenu vzemite čas za uživanje v čudovitih razgledih na Ljubljano, reko Savo, okoliške hribe ter Alpe. Vrh s slikovito cerkvijo ponuja eno najlepših panoram v osrednji Sloveniji.',

  // ── GALLERY ──
  'gallery.badge': 'Galerija',
  'gallery.title': 'ŠMarna gora skozi objektiv',
  'gallery.subtitle': 'Trenutki, ki oživijo duh gora — vsaka fotografija pripoveduje svojo zgodbo',
  'gallery.enlarge': 'Povečaj',
  'gallery.close': 'Zapri predogled',
  'gallery.prev': 'Prejšnja slika',
  'gallery.next': 'Naslednja slika',
  'gallery.open': 'Odpri sliko',

  // ── WEATHER ──
  'weather.badge': 'Živo vreme',
  'weather.title': 'VREME NA ŠMARNI GORI',
  'weather.loading': 'Osvežujem...',
  'weather.updated': 'Nazadnje',
  'weather.current': 'Trenutno',
  'weather.feels_like': 'Občutek',
  'weather.wind': 'Veter',
  'weather.humidity': 'Vlažnost',
  'weather.visibility': 'Vidljivost',
  'weather.cloud_cover': 'Oblačnost',
  'weather.uv_index': 'UV indeks',
  'weather.rain': 'Dež',
  'weather.hiking_score': 'Ocena za pohod',
  'weather.out_of': 'od 100 točk',
  'weather.trail_safety': 'Varnost poti',
  'weather.safety_optimal': 'Varne razmere',
  'weather.safety_caution': 'Potrebna previdnost',
  'weather.safety_warning': 'Otežene razmere',
  'weather.safety_danger': 'Nevarne razmere',
  'weather.no_alerts': 'Brez posebnih opozoril',
  'weather.best_time': 'Najboljši čas za pohod',
  'weather.next_hours': 'Naslednje ure',
  'weather.seven_day': '7-dnevna napoved',
  'weather.disclaimer': 'Podatki so informativne narave. Pred pohodom vedno preverite uradno vremensko napoved. Vir: Open-Meteo API.',
  'weather.error_load': 'Vremenskih podatkov ni bilo mogoče naložiti',
  'weather.error_stale': 'Prikazujem zadnje shranjene podatke',
  'weather.smarna_elevation': 'Šmarna gora, 669m',

  // ── SAFETY ──
  'safety.badge': 'Pomembno',
  'safety.title': 'VARNOST NA POTI',
  'safety.slippery_title': 'Spolzka podlaga',
  'safety.slippery_desc': 'Po dežju so korenine in skale izjemno spolzke. Nosite pohodne čevlje z dobrim oprijemom. Izogibajte se bližnjicam čez moker teren.',
  'safety.winter_title': 'Zimski pogoji',
  'safety.winter_desc': 'Pozimi so poti lahko poledenele. Obvezna je zimska oprema: dereze, pohodne palice. Preverite vreme pred odhodom.',
  'safety.sunset_title': 'Sončni vzhod / zahod',
  'safety.sunset_desc': 'Če se odpravljate na sončni vzhod ali zahod, obvezno vzemite čelno svetilko. Vedno povejte nekomu kam greste.',
  'safety.emergency_title': 'Nujna pomoč',
  'safety.emergency_desc': 'V nujnih primerih pokličite 112. Aplikacija Gorska reševalna služba omogoča hitro lociranje. Shranite številko pred pohodom.',
  'safety.warning_title': 'OPOZORILO',
  'safety.warning_text': 'Informacije na tej strani so informativne narave. Pohodi potekajo na lastno odgovornost. Pred vsakim pohodom preverite vremenske razmere, primerno opremo in svoje fizične sposobnosti. STEZA ne prevzema odgovornosti za morebitne poškodbe ali nezgode.',

  // ── FACEBOOK ──
  'facebook.badge': 'Skupnost',
  'facebook.title': 'PRIDRUŽITE SE NAM',
  'facebook.desc': 'Sledite STEZA.SI na Facebooku za najnovejše informacije, dogodke in fotografije',
  'facebook.label': 'Facebook skupnost',

  // ── WEBCAM ──
  'webcam.badge': 'V živo',
  'webcam.title': 'SPLETNA KAMERA ŠMARNE GORE',
  'webcam.desc': 'Pogled v živo z vrha Šmarne gore — kmalu na voljo',
  'webcam.coming_soon': 'Spletna kamera bo kmalu na voljo',
  'webcam.preparing': 'Pripravljamo prenos slike v živo z vrha Šmarne gore. Hvala za potrpežljivost.',
  'webcam.status': 'V pripravi',

  // ── MEDIA ──
  'media.badge': 'Mediji',
  'media.title': 'GALERIJA & VIDEO',
  'media.desc': 'Kinematografski posnetki in fotografije Šmarne gore — kmalu na voljo',
  'media.drone': 'DRONE VIDEO V PRIPRAVI',
  'media.drone_desc': 'Kinematografski posnetek Poti na Peske',
  'media.views': 'Razgledi',
  'media.trail': 'Pot',
  'media.history': 'Zgodovina',

  // ── FOOTER ──
  'footer.desc': 'Pot na Peske — Šmarna gora. Turistično društvo STEZA. Premium pohodniška izkušnja s profesionalnimi informacijami o poteh, vremenu in varnosti.',
  'footer.newsletter_title': 'Prejemaj novice o poteh',
  'footer.newsletter_success': 'Hvala! Prijavljeni ste na novice STEZA.',
  'footer.newsletter_placeholder': 'Vpiši svoj e-mail',
  'footer.newsletter_btn': 'Prijavi se',
  'footer.trails': 'Poti',
  'footer.platform': 'Platforma',
  'footer.legal': 'Pravno',
  'footer.pot_peske': 'Naša pot na Peske',
  'footer.pot_korenine': 'Pot na korenine',
  'footer.mazijeva': 'Mazijeva pot',
  'footer.romarska': 'Romarska pot',
  'footer.plezalna': 'Plezalna pot',
  'footer.izhodisca': 'Izhodišča',
  'footer.galerija': 'Galerija',
  'footer.vreme': 'Vreme',
  'footer.o_stezi': 'O STEZI',
  'footer.kontakt': 'Kontakt',
  'footer.privacy': 'Pravilnik zasebnosti',
  'footer.cookies': 'Piškotki',
  'footer.disclaimer': 'Oprostitev odgovornosti',
  'footer.safety_notice': 'Varnostno obvestilo',
  'footer.copyright': '© 2026 STEZA.SI — Turistično društvo STEZA, Šmarna gora',
  'footer.disclaimer_text': 'Pomembno opozorilo: Informacije na strani so informativne narave. Pohodi in aktivnosti v naravi potekajo na lastno odgovornost. Pred obiskom preverite vremenske razmere, primerno opremo in stanje poti.',
  'footer.facebook_label': 'STEZA na Facebooku',
  'footer.instagram_label': 'STEZA na Instagramu',

  // ── ABOUT PAGE ──
  'about.hero_title': 'O STEZI',
  'about.hero_subtitle': 'Premium pohodniška platforma, ustvarjena z ljubeznijo do Šmarne gore.',
  'about.story_badge': 'Naša zgodba',
  'about.story_title': 'Najlepša pot na Šmarno goro',
  'about.story_p1': 'STEZA je nastala iz preproste ideje: pohod na Šmarno goro je lahko več kot samo rekreacija — lahko je doživetje. Ustvarili smo platformo, ki združuje profesionalne pohodniške informacije z vrhunsko estetiko in moderno tehnologijo.',
  'about.story_p2': 'Smo ekipa pohodnikov, fotografov in oblikovalcev, ki verjamemo, da si vsaka gora zasluži svojo premium predstavitev. Šmarna gora ni samo hrib — je simbol Ljubljane, romarski cilj, naravni biser in športni poligon v enem.',
  'about.story_p3': 'STEZA ni turistični portal. Ni blog. Je premium cinematic hiking platform za vse, ki želijo odkriti Šmarno goro na drugačen način.',
  'about.elevation_label': 'Šmarna gora',
  'about.elevation': '669 m n. m.',
  'about.how_title': 'Kako je nastala STEZA',
  'about.how_p1': 'Zgodba se je začela na vrhu Šmarne gore. Stali smo na razgledni ploščadi, gledali proti Alpam in se spraševali: zakaj tako čudovit hrib nima moderne, pregledne in lepe predstavitve na spletu? Vse kar smo našli so bili raztreseni forumski zapisi, zastareli blogi in nizkokakovostne fotografije. In takrat smo se odločili — ustvarili bomo nekaj drugačnega.',
  'about.how_p2': 'Naslednjih šest mesecev smo preživeli na terenu. Prehodili smo vsako pot — od najlažje do najzahtevnejše. Fotografirali smo sončne vzhode, deževne gozdove, zasnežene vrhove in zlate zahode. Pogovarjali smo se z lokalnimi vodniki, gostilničarji, starejšimi pohodniki in prvoobiskovalci. Želeli smo razumeti Šmarno goro iz vsakega zornega kota.',
  'about.how_p3': 'STEZA ni samo spletna stran. Je vizualni dnevnik naše ljubezni do te gore. Vsaka fotografija je profesionalno posneta, vsaka pot je osebno prehojena, vsak podatek je preverjen. Verjamemo, da si Šmarna gora — kot ena najbolj obiskanih pohodniških točk v Sloveniji — zasluži predstavitev svetovnega razreda.',
  'about.how_p4': 'Navdih za oblikovanje smo črpali iz premium outdoor znamk, kot so Patagonia, The North Face in National Geographic Travel. Želeli smo ustvariti platformo, ki diha avanturo, a hkrati ostaja minimalistična, čista in profesionalna.',
  'about.how_p5': 'Danes STEZA pokriva štiri glavne poti na Šmarno goro, vremenske podatke v živo, GPS navigacijo, varnostne napotke in bogato galerijo. A to je šele začetek. Naša vizija je postati najboljša pohodniška platforma v Sloveniji — in Šmarna gora je naš prvi, najljubši projekt.',
  'about.gora_badge': 'Spoznajte goro',
  'about.gora_title': 'Šmarna gora — srce naše zgodbe',
  'about.gora_subtitle': '669 metrov, ki povezujejo generacije',
  'about.gora_p1': 'Šmarna gora (669 m) je najbolj priljubljen izletniški vrh v osrednji Sloveniji. Leži le 10 kilometrov severozahodno od Ljubljane, a kljub bližini mesta ponuja pristen stik z naravo, bogato zgodovino in osupljive razglede.',
  'about.gora_p2': 'Gre za osamelec — hrib, ki geološko ne spada v nobeno večje gorovje, ampak se samostojno dviga nad Ljubljansko kotlino. Sestavljen je iz apnenca in dolomita, njegova južna pobočja pa so znana po toploljubnih rastlinskih vrstah.',
  'about.gora_p3': 'Skozi stoletja je bila Šmarna gora vse: prazgodovinska naselbina, strateška točka z gradom Šumberk, romarski cilj, priljubljena izletniška točka meščanov, danes pa je nepogrešljiv del športne in kulturne identitete Ljubljane.',
  'about.history_title': 'Zgodovina, zapisana v kamnu',
  'about.history_bronze_date': '1500 pr. n. št.',
  'about.history_bronze_title': 'Bronasta doba',
  'about.history_bronze_text': 'Arheološke najdbe na vrhu pričajo o prazgodovinski naselbini. Lončenina, orodje in ostanki bivališč kažejo na stalno poselitev v bronasti dobi.',
  'about.history_castle_date': '12.–13. st.',
  'about.history_castle_title': 'Grad Šumberk',
  'about.history_castle_text': 'Na vrhu je stal srednjeveški grad Šumberk (Schönberg). Danes so od njega ostali le skromni arheološki sledovi in legende o vitezih.',
  'about.history_church_date': '1711',
  'about.history_church_title': 'Cerkev Matere Božje',
  'about.history_church_text': 'Zgrajena baročna cerkev na mestu starejše gotske cerkve iz 14. stoletja. Postane osrednji romarski cilj osrednje Slovenije.',
  'about.history_modern_date': '19. st.–danes',
  'about.history_modern_title': 'Planinska točka',
  'about.history_modern_text': 'Z razvojem planinstva postane najbolj priljubljena izletniška točka Ljubljančanov. Ta status drži še danes z več kot 500.000 obiskovalci letno.',
  'about.nature_title': 'Narava, ki navdihuje',
  'about.nature_p1': 'Južna pobočja Šmarne gore so botanični raj. Toplo mikroklimo izkoriščajo rastline, ki jih sicer najdemo bistveno južneje: črni teloh zacveti že februarja, sledijo mu dišeča perunika, navadni kosmatinec in jesenski podlesek.',
  'about.nature_p2': 'Gozdovi so mešani — prevladujejo bukev, hrast in smreka, na vrhu pa raste mogočen kostanj. Živalski svet vključuje srne, lisice, divje prašiče, jazbece, veverice in polhe.',
  'about.nature_p3': 'Spodbujamo odgovorno pohodništvo — ne puščajte sledi, ne trgajte rastlin, ne vznemirjajte živali in odnesite smeti s seboj v dolino.',
  'about.legends_title': 'Legende, ki živijo',
  'about.legend_bell_title': 'Zvon želja',
  'about.legend_bell_text': 'Najbolj znana legenda Šmarne gore. Če trikrat pozvoniš — prvič za zdravje, drugič za srečo in tretjič za ljubezen — in si pri vsakem zvonjenju nekaj zaželiš, se ti bo želja uresničila.',
  'about.legend_castle_title': 'Grad Šumberk in zaklad',
  'about.legend_castle_text': 'Legenda pravi, da so vitezi gradu Šumberk pred odhodom v križarske vojne zakopali zlat zaklad nekje na pobočjih Šmarne gore. Nihče ga ni nikoli našel.',
  'about.legend_mary_title': 'Marijina prikazen',
  'about.legend_mary_text': 'Po ljudskem izročilu naj bi se na vrhu hriba prikazala Devica Marija, po čemer je gora dobila ime. To izročilo je botrovalo izgradnji cerkve in romarski tradiciji.',
  'about.stats_title': 'STEZA v številkah',
  'about.values_title': 'Naše vrednote',
  'about.values.professionalism': 'Profesionalnost',
  'about.values.professionalism_text': 'Vse informacije so skrbno preverjene in redno posodobljene. Sodelujemo z lokalnimi vodniki in Gorsko reševalno službo.',
  'about.values.aesthetics': 'Estetika',
  'about.values.aesthetics_text': 'Verjamemo, da so lepi vizualni elementi ključni za navdih. Vsaka fotografija na strani je profesionalno posneta in kurirana.',
  'about.values.safety': 'Varnost',
  'about.values.safety_text': 'Varnost je na prvem mestu. Vsaka pot vključuje natančna opozorila, priporočeno opremo in varnostne napotke.',
  'about.values.passion': 'Strast',
  'about.values.passion_text': 'STEZA je projekt iz strasti. Vsak član ekipe je pohodnik, ki osebno pozna vsako pot na Šmarno goro.',
  'about.values.sustainability': 'Trajnost',
  'about.values.sustainability_text': 'Spodbujamo odgovorno pohodništvo. Ne puščajte sledi, spoštujte naravo in divje živali, odnesite smeti s seboj.',
  'about.values.community': 'Skupnost',
  'about.values.community_text': 'Gradimo skupnost pohodnikov, ki si delijo izkušnje in pomagajo drug drugemu pri odkrivanju Šmarne gore.',
  'about.cta_title': 'Pridružite se STEZI',
  'about.cta_subtitle': 'Vsaka pot ima zgodbo. Odkrijte jo z nami.',
  'about.cta_explore': 'Razišči poti',
  'about.cta_contact': 'Kontaktiraj nas',

  // ── CONTACT PAGE ──
  'contact.hero_title': 'Kontakt',
  'contact.hero_subtitle': 'Imate vprašanje, predlog ali želite sodelovati? Pišite nam ali pokličite.',
  'contact.write_us': 'Pišite nam',
  'contact.email_label': 'E-pošta',
  'contact.phone_label': 'Telefon',
  'contact.location_label': 'Lokacija',
  'contact.location_value': 'Šmarna gora, 1211 Ljubljana-Šmartno, Slovenija',
  'contact.follow_us': 'Sledite nam',
  'contact.success_title': 'Hvala za sporočilo!',
  'contact.success_text': 'Odgovorili vam bomo v najkrajšem možnem času.',
  'contact.name_label': 'Ime',
  'contact.name_placeholder': 'Vaše ime',
  'contact.email_placeholder': 'vasa@posta.si',
  'contact.message_label': 'Sporočilo',
  'contact.message_placeholder': 'Vaše sporočilo (največ 500 znakov)',
  'contact.submit': 'Pošlji sporočilo',
  'contact.error_fields': 'Prosimo, izpolnite vsa polja.',
  'contact.error_length': 'Sporočilo je predolgo. Največ 500 znakov.',
  'contact.error_general': 'Prišlo je do napake. Poskusite znova.',

  // ── ROUTES PAGE ──
  'routes.hero_title': 'Poti',
  'routes.hero_subtitle': 'Pet edinstvenih poti na vrh Šmarne gore. Od lahke Poti na Peske do zahtevnih plezalnih smeri — izberite svojo STEZO.',
  'routes.explore': 'Razišči pot',
  'routes.compare_title': 'Primerjava poti',
  'routes.table_pot': 'Pot',
  'routes.table_tezavnost': 'Težavnost',
  'routes.table_trajanje': 'Trajanje',
  'routes.table_visinska': 'Višinska',
  'routes.table_dolzina': 'Dolžina',
  'routes.table_tip': 'Tip',
  'routes.cta_title': 'Pripravljeni na svojo STEZO?',
  'routes.cta_subtitle': 'Izberite pot, ki vam najbolj ustreza, in odkrijte Šmarno goro na način, ki si ga boste zapomnili.',
  'routes.cta_find': 'Poišči startno točko',
  'routes.cta_weather': 'Preveri vreme',
  'routes.difficulty_easy': 'Lažje',
  'routes.difficulty_moderate': 'Zmerno',
  'routes.difficulty_hard': 'Zahtevno',

  // ── GALLERY PAGE ──
  'gallery_page.badge': 'Fotografska zbirka',
  'gallery_page.title': 'Galerija',
  'gallery_page.subtitle': 'Zbirka fotografij s Šmarne gore — poti, razgledi in trenutki, ki jih delimo.',
  'gallery_page.section_trail_title': 'Pot do vrha',
  'gallery_page.section_trail_subtitle': 'Pohodniške poti skozi gozd in naravo med vzponom',
  'gallery_page.section_summit_title': 'Vrh',
  'gallery_page.section_summit_subtitle': 'Razgledi, panorama in trenutki na vrhu Šmarne gore',
  'gallery_page.section_parking_title': 'Parking',
  'gallery_page.section_parking_subtitle': 'Dostop do izhodišča in parkirna mesta skozi vse letne čase',
  'gallery_page.empty_title': 'Sekcija {title} je pripravljena. Dodaj slike in se bodo prikazale tukaj.',
  'gallery_page.empty_subtitle': 'Sekcija je pripravljena.',
  'gallery_page.close': 'Zapri galerijo',
  'gallery_page.prev': 'Prejšnja slika',
  'gallery_page.next': 'Naslednja slika',
  'gallery_page.open': 'Ogled slike',
  'gallery_page.cta_title': 'Posnemite svojo fotografijo',
  'gallery_page.cta_subtitle': 'Najlepše fotografije nastanejo na vrhu. Delite svoje najboljše posnetke z oznako #STEZA.',
  'gallery_page.cta_btn': 'Najdi svojo pot',

  // ── LEGAL PAGE ──
  'legal.not_found': 'Stran ni najdena',
  'legal.back_home': '← Nazaj domov',
  'legal.updated': 'Zadnja posodobitev',
  'legal.copyright': '© 2026 STEZA.SI — Vse pravice pridržane. Kontakt: info@steza.si',

  // ── NOT FOUND ──
  'notfound.title': 'Ta stran še ni bila ustvarjena',
  'notfound.subtitle': 'Povejte mi več o tej strani, da jo lahko ustvarim',
  'notfound.back_home': 'Nazaj na domačo stran',

  // ── LANGUAGE SWITCHER ──
  'lang.sl': 'Slovenščina',
  'lang.en': 'English',
  'lang.de': 'Deutsch',
  'lang.it': 'Italiano',
  'lang.hr': 'Hrvatski',
  'lang.es': 'Español',
  'lang.ru': 'Русский',

  // ── SEO ──
  'seo.home_title': 'Pot na Peske — Šmarna gora | STEZA — Premium pohodniška platforma',
  'seo.home_desc': 'Pot na Peske je ena najlepših poti na Šmarno goro. Premium pohodniška izkušnja s profesionalnimi informacijami o poteh, vremenu, varnosti in razgledih. Turistično društvo STEZA.',
  'seo.home_keywords': 'Pot na Peske, Šmarna gora, pohod na Šmarno goro, hiking Slovenia, Šmarna gora poti, Pirniče Šmarna gora, planinstvo Ljubljana',
  'seo.og_title': 'Pot na Peske — Šmarna gora | STEZA',
  'seo.og_desc': 'Premium pohodniška platforma za Šmarno goro. Odkrij Pot na Peske — eno najlepših in najbolj prijaznih poti na Šmarno goro.',
  'seo.schema_desc': 'Pot na Peske je ena najlepših poti na Šmarno goro. Turistično društvo STEZA — premium pohodniška platforma za Šmarno goro.',
};